import React from 'react';

const Footer = () => {
  return (
    <div>
      <div className="container-fluid">
        <footer className="row border-top">
          <div className="col-md-3 mb-3">
            <p className="text-muted">© 2024 - Created By Manas Kirve </p>
          </div>

      
        </footer>
      </div>
    </div>
  );
};

export default Footer;
